import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {Box, Grid, useToken} from '@chakra-ui/react';
import {Tooltip} from 'react-tooltip';
import Latex from 'react-latex-next';
import {VersionItem} from 'api';

interface IProps {
  versions: Array<VersionItem>;
}

const TOOLTIP_ID = 'VERSION_TOOLTIP_';

const VersionsViewerFC: FC<IProps> = ({versions}) => {
  const [borderHex] = useToken('colors', ['border']);

  return (
    <Box
      p={'2px'}
      borderRadius={'4px'}
      border={'1px solid'}
      borderColor={'border'}
      maxH={'calc(var(--height-layout) - 120px)'}
      overflow={'auto'}
    >
      {versions.map((v, i) => (
        <Grid
          p={'4px 6px'}
          key={`${v.name}${i}`}
          borderRadius={'3px'}
          gridTemplateColumns={'1fr 120px'}
          _hover={{bg: 'accentMid', cursor: 'pointer'}}
          data-tooltip-id={`${TOOLTIP_ID}_${i}`}
        >
          <Box className={'cut-text'}>{v.name}</Box>
          <Box textAlign={'right'}>{v.version}</Box>

          <Tooltip
            id={`${TOOLTIP_ID}_${i}`}
            delayShow={250}
            place={'bottom'}
            border={`1px solid ${borderHex}`}
            closeEvents={{click: true, mouseleave: true}}
            style={{padding: '0', backgroundColor: 'white', zIndex: 10}}
            opacity="1"
          >
            <Box maxW="360px" color="bodyText" p="6px 10px" fontSize="12px">
              <Latex>{v.name}</Latex>
            </Box>
          </Tooltip>
        </Grid>
      ))}
    </Box>
  );
};

export const VersionsViewer = observer(VersionsViewerFC);
